import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import cx from 'clsx';
import {
  BottomSheet,
  Button,
  Checkbox,
  Selectbox,
  TextareaField,
} from '@kcd/design-system';

import styles from './ProductInquireBottomSheet.module.css';

type ProductInquireType = 'PRODUCT' | 'DELIVERY' | 'RESTOCK' | 'ETC';
export type ProductInquireFormValue = {
  content: string;
  isSecret: boolean;
  type: ProductInquireType;
};
type Props = Omit<React.ComponentProps<typeof BottomSheet>, 'children'> & {
  onSubmit?(value: ProductInquireFormValue): void;
  defaultValues?: ProductInquireFormValue;
};
function ProductInquireBottomSheet({
  defaultValues,
  onSubmit,
  ...props
}: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<ProductInquireFormValue>();

  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues);
    } else {
      reset({ content: '', isSecret: false, type: 'PRODUCT' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  useEffect(() => {
    if (!props.opened) {
      reset({ content: '', isSecret: false, type: 'PRODUCT' });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opened]);

  const onFinish = (data: ProductInquireFormValue) => {
    onSubmit?.(data);
  };

  return (
    <BottomSheet
      {...props}
      className={cx('z-20', props.className)}
      title="상품 문의 작성"
      actions={[
        <Button block key="1" type="submit" form="inquire-form">
          등록
        </Button>,
      ]}
    >
      <form onSubmit={handleSubmit(onFinish)} id="inquire-form">
        <Selectbox
          {...register('type', { required: true })}
          placeholder="상품문의 유형을 선택하세요."
          error={!!errors.type}
          className={styles.item}
        >
          <option value="PRODUCT">상품문의</option>
          <option value="DELIVERY">배송문의</option>
          <option value="RESTOCK">재입고문의</option>
          <option value="ETC">기타</option>
        </Selectbox>

        <TextareaField
          {...register('content', { required: true })}
          placeholder="문의 내용을 작성하세요."
          error={!!errors.content}
          className={styles.item}
        />

        <Checkbox {...register('isSecret')}>비밀글로 문의하기</Checkbox>
      </form>
    </BottomSheet>
  );
}

export default ProductInquireBottomSheet;
